module.exports = __webpack_public_path__ + "static/media/submitimg.9ba5b43e.png";